module.exports = __webpack_public_path__ + "img/Thailand.8e1165e4.gif";